export default __webpack_public_path__ + "static/media/Logo_Portis_256h.753166ff.png";